module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-ni.c4edefe2.png";